import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { TRADITIONS } from "@/data/content";
import { Reveal, Eyebrow, SectionTitle } from "@/components/common";

export default function Traditions() {
  const list = Object.entries(TRADITIONS);
  return (
    <div className="pt-16 lg:pt-[72px]" data-testid="traditions-page">
      <section className="py-20 lg:py-28 border-b border-indic-gold/15">
        <div className="mx-auto max-w-[1400px] px-4 sm:px-8">
          <Eyebrow>Living Traditions</Eyebrow>
          <h1 className="mt-4 font-serif text-5xl lg:text-6xl font-semibold text-amber-50">Discover Traditions</h1>
          <p className="mt-5 max-w-2xl text-lg text-slate-300/90 leading-relaxed">
            Studied as living traditions rather than settled dogma — with respect for their adherents and freedom to inquire, compare, and question.
          </p>
          <Link to="/compare" className="mt-6 inline-flex items-center gap-2 rounded-sm border border-indic-gold/50 px-6 py-3 font-semibold text-amber-50 hover:bg-indic-gold/10 transition-colors" data-testid="traditions-compare-btn">
            Compare traditions side by side <ArrowRight size={15} />
          </Link>
        </div>
      </section>
      <section className="py-16 lg:py-24">
        <div className="mx-auto max-w-[1400px] px-4 sm:px-8 grid grid-cols-1 md:grid-cols-2 gap-6">
          {list.map(([slug, t], i) => (
            <Reveal key={slug} delay={(i % 2) * 0.1}>
              <Link to={`/traditions/${slug}`} className="group relative block h-80 overflow-hidden rounded-sm border border-indic-card-border" data-testid={`tradition-card-${slug}`}>
                <img src={t.img} alt={t.name} className="absolute inset-0 h-full w-full object-cover opacity-50 transition-all duration-700 group-hover:scale-105 group-hover:opacity-65" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B1021] via-[#0B1021]/50 to-transparent" />
                <div className="absolute inset-0 flex flex-col justify-end p-8">
                  <span className="font-deva text-2xl mb-2" style={{ color: t.accent }}>{t.sanskrit}</span>
                  <h3 className="font-serif text-4xl font-semibold text-amber-50">{t.name}</h3>
                  <p className="mt-1 font-serif italic text-lg text-amber-100/80">{t.tagline}</p>
                  <p className="mt-3 max-w-md text-sm text-slate-300/85 leading-relaxed line-clamp-2">{t.intro}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-indic-gold">Enter tradition <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" /></span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
